import { urls } from '~/preloaded';
import { get, post } from '~/helpers/api';

import type { IApiGetAccountStateResponse, IApiGetMembersResponse, IPatrolId } from '~/types/patrols';

const API_VERSION = 'v1';
const API_ENDPOINTS = {
  ACCOUNT_STATE: `/api/${API_VERSION}/accounts/state/`,
  ACCOUNTS: `/api/${API_VERSION}/patrols/accounts/`,
  JOIN: `/api/${API_VERSION}/patrols/join/`,
  REWARDS_UPDATE: `/api/${API_VERSION}/rewards/update/`,
  REWARDS_CLAIM: `/api/${API_VERSION}/rewards/claim/`,
  BONUS_CLAIM: `/api/${API_VERSION}/bonus/claim/`,
};

export const PATROLS_RESPONSE_OK_STATUS = 'ok';

export const fetchPatrolsAccounts = async (patrols: IPatrolId[], signal?: AbortSignal) => {
  if (!urls.clanpatrols) {
    return null;
  }

  const url = `${urls.clanpatrols}${API_ENDPOINTS.ACCOUNTS}`;
  return await post<IApiGetMembersResponse>(url, { ids: patrols }, signal && { signal });
};

export const fetchPatrolsAccountState = async (signal?: AbortSignal) => {
  if (!urls.clanpatrols) {
    return null;
  }

  const url = `${urls.clanpatrols}${API_ENDPOINTS.ACCOUNT_STATE}`;
  return await get<IApiGetAccountStateResponse>(url, {}, signal && { signal });
};

export const joinPatrol = async (id: IPatrolId) => {
  if (!urls.clanpatrols) {
    return null;
  }

  const url = `${urls.clanpatrols}${API_ENDPOINTS.JOIN}`;
  return await post<{ status: string }>(url, { id });
};

export const rewardsRefresh = async () => {
  if (!urls.clanpatrols) {
    return null;
  }

  const url = `${urls.clanpatrols}${API_ENDPOINTS.REWARDS_UPDATE}`;
  return await post<{ status: string }>(url, {});
};

export const rewardsClaim = async () => {
  if (!urls.clanpatrols) {
    return null;
  }

  const url = `${urls.clanpatrols}${API_ENDPOINTS.REWARDS_CLAIM}`;
  return await post<{ status: string }>(url, {});
};

export const bonusClaim = async () => {
  if (!urls.clanpatrols) {
    return null;
  }

  const url = `${urls.clanpatrols}${API_ENDPOINTS.BONUS_CLAIM}`;
  return await post<{ status: string }>(url, {});
};
